import { useListState } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import { LogDto } from '../../Types/LogT';
import { LogS } from '../LogS';
import { deleteLog } from '../restapi/logService';

// eslint-disable-next-line import/prefer-default-export
export const useNotes = (entityType?: string | null, entityId?: string | null) => {
  const [notes, handlers] = useListState<LogDto>([]);
  const [loading, setLoading] = useState(false);
  const [addingNote, setAddingNote] = useState(false);
  const { prepend, applyWhere, filter, setState } = handlers;

  useEffect(() => {
    if (entityId && entityType) {
      setLoading(true);
      LogS.getLogs('notes', entityType, entityId)
        .then(setState)
        .finally(() => setLoading(false));
    }
  }, [entityId, entityType, setState]);

  const update = async (id: string, patch: Partial<LogDto>) => {
    const resJSON = await LogS.editNote(id, patch);
    if (resJSON) {
      applyWhere(
        (n) => id === n.id,
        () => resJSON,
      );
      return true;
    }
    return false;
  };

  const add = async () => {
    if (entityId && entityType) {
      setAddingNote(true);
      const note = await LogS.createNote({
        entityId,
        entityType,
        logType: 'notes',
      });
      setAddingNote(false);
      if (note) prepend(note);
    }
  };

  const remove = async (id: string) => {
    const resp = await deleteLog(id);
    if (resp.ok) {
      filter((note) => note.id !== id);
      return true;
    }
    return false;
  };

  return {
    loading,
    addingNote,
    notes,
    add,
    update,
    remove,
  };
};
